//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: false,
            entries: [],
            pagination: {},
            showIndices: []
        };
    },

    mounted () {
        this.loadFAQs();
    },

    methods: {
        loadFAQs () {
            this.loading = true;

            axios.get('faqs/published', {
                limit: 0
            }).then(response => {
                this.entries = response.data.data;
                this.pagination = this.$helper.getPaginationData(response);
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        toggle (index) {
            this.showIndices = _.xor(this.showIndices, [index]);
        }
    }
}
